/* [[ AUTO GENERATED - DO NOT MODIFY ]] */
/**
 * @deprecated Use {@see DocumentType} instead.
 */
export const OrderDocumentType = {
    INVOICE: 'invoice',
    RETURN: 'return',
    DELIVERY_NOTE: 'delivery_note',
    SHIPPING_LABEL: 'shipping_label'
};
